import useSnapshot from "./useSnapshot";

export default function useCollectionOnce(query) {
	return useSnapshot(query, false);
}
